/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SaveIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="save"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M5.5 3.5C4.395 3.5 3.5 4.395 3.5 5.5L3.5 18.5C3.5 19.605 4.395 20.5 5.5 20.5L18.5 20.5C19.605 20.5 20.5 19.605 20.5 18.5L20.5 8.828C20.5 8.298 20.289 7.789 19.914 7.414L16.586 4.086C16.211 3.711 15.702 3.5 15.172 3.5L5.5 3.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8 3.99L8 6C8 7.105 8.895 8 10 8L14 8C15.105 8 16 7.105 16 6L16 4" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17 20.15L17 14.5C17 13.395 16.105 12.5 15 12.5L9 12.5C7.895 12.5 7 13.395 7 14.5L7 20.17" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
